/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
require('../vendor/picker');
require('../vendor/picker.date');
require('../vendor/picker.time');
require('../vendor/picker.localizations');
import abidePhoneNumberInputValidator from '../utils/abide-phone-number-input-validator';

if (!window.App) { window.App = {}; }

App.init = function() {
  if (window.matchMedia('(pointer: coarse)').matches) {
    // this device is probably a touch device
    $('body').addClass('touch');
  } else {
    $('body').addClass('no-touch');
  }

  Foundation.Abide.defaults.validators['selected_value'] =
    window.abideSelectedValue;

  Foundation.Abide.defaults.validators['phone_number_input'] = abidePhoneNumberInputValidator;

  $(document).foundation();

  Ladda.bind('.ladda');

  $('[data-behavior~=facebook-share]').click(function(e) {
    e.preventDefault();
    return FB.ui({
      method: 'share',
      display: 'popup',
      href: $(this).data('url')
    }, function(response) {});
  });

  return $('[data-href]').on('click', function() {
    return window.location.href = $(this).data('href');
  });
};

$(document).ready(() => App.init());
